import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { projectManagementResTpoFundModelImport } from '/imports/api/projectManagement';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';
import { FileInput } from '/imports/ui/FileInput';
import { Loading } from '/imports/ui/Loading';
import { maxSpreadsheetUploadBytes } from '/imports/api/files';

/** Dev tool: price the residential SGIP projects from the Prepaid PPA Fund Model workbook. */
export const DevToolFundModelImport = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const run = toastOnError(async (file: any) => {
    if (!file || loading) return;
    setLoading(true);
    setResult('');
    try {
      const res = await projectManagementResTpoFundModelImport.call({ file });
      setResult(JSON.stringify(res, null, 2));
      toast.success(strings.FundModelImported(res.matched, res.rows, res.parameters));
    }
    finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection title={strings.FundModelImport()} description={strings.FundModelImportHelp()}>
      <FileInput placeholder={loading ? strings.Importing() : strings.UploadFundModel()} maxSize={maxSpreadsheetUploadBytes} onChange={(file) => run(file)} />
      {loading && <Loading caption={strings.ImportingTracker()} />}
      {!loading && result && <pre>{result}</pre> || null}
    </DevToolSection>
  );
};
